import MultipleSubQuestionsYesNoAnswerForm from './MultipleSubQuestionsYesNoAnswerForm';

export default MultipleSubQuestionsYesNoAnswerForm;
